import React from 'react';

export function SmallSkeleton({ ...props }) {
    return (
        <svg
            fill="none"
            opacity="0"
            style={{ paddingTop: 15 }}
            viewBox="0 0 501 275"
            width="100%"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <animate attributeName="opacity" begin="1s" dur="1s" repeatCount="indefinite" values="0;1;0" />
            <rect fill="white" height="275" width="501" />
            <rect fill="white" height="273" width="499" x="1" y="1" />
            <rect height="273" stroke="#EFEFF0" strokeWidth="2" width="499" x="1" y="1" />
            <rect fill="black" fillOpacity="0.04" height="40" rx="20" width="40" x="30" y="30" />
            <path
                d="M85 39C85 38.4477 85.4477 38 86 38H470C470.552 38 471 38.4477 471 39V61C471 61.5523 470.552 62 470 62H86C85.4477 62 85 61.5523 85 61V39Z"
                fill="black"
                fillOpacity="0.04"
            />
            <path
                d="M30 86C30 85.4477 30.4477 85 31 85H470C470.552 85 471 85.4477 471 86V244C471 244.552 470.552 245 470 245H31C30.4477 245 30 244.552 30 244V86Z"
                fill="black"
                fillOpacity="0.04"
            />
        </svg>
    );
}

export function BigSkeleton({ ...props }) {
    return (
        <svg
            fill="none"
            opacity="0"
            style={{ marginTop: 15 }}
            viewBox="0 0 1051 481"
            width="100%"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <animate attributeName="opacity" begin="1s" dur="1s" repeatCount="indefinite" values="0;1;0" />
            <g>
                <path
                    d="M0 1C0 0.447715 0.447715 0 1 0H295C295.552 0 296 0.447715 296 1V27C296 27.5523 295.552 28 295 28H1C0.447719 28 0 27.5523 0 27V1Z"
                    fill="black"
                    fillOpacity="0.04"
                />
                <rect fill="white" height="421" width="1051" y="60" />
                <rect height="419" stroke="black" strokeOpacity="0.04" strokeWidth="2" width="1049" x="1" y="61" />
                <rect fill="black" fillOpacity="0.04" height="48" rx="24" width="48" x="30" y="90" />
                <path
                    d="M98 91C98 90.4477 98.4477 90 99 90H1020C1020.55 90 1021 90.4477 1021 91V120C1021 120.552 1020.55 121 1020 121H99C98.4477 121 98 120.552 98 120V91Z"
                    fill="black"
                    fillOpacity="0.04"
                />
                <path
                    d="M98 137C98 136.448 98.4477 136 99 136H1020C1020.55 136 1021 136.448 1021 137V375C1021 375.552 1020.55 376 1020 376H99C98.4477 376 98 375.552 98 375V137Z"
                    fill="black"
                    fillOpacity="0.04"
                />
                <path
                    d="M871 407C871 406.448 871.448 406 872 406H1020C1020.55 406 1021 406.448 1021 407V450C1021 450.552 1020.55 451 1020 451H872C871.448 451 871 450.552 871 450V407Z"
                    fill="black"
                    fillOpacity="0.04"
                />
            </g>
        </svg>
    );
}

export function TopSkeleton({ ...props }) {
    return (
        <svg
            fill="none"
            height="250px"
            opacity="0"
            viewBox="0 0 1600 323"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <animate attributeName="opacity" begin="1s" dur="1s" repeatCount="indefinite" values="0;1;0" />
            <path
                d="M0 17C0 16.4477 0.447715 16 1 16H230C230.552 16 231 16.4477 231 17V47C231 47.5523 230.552 48 230 48H1.00001C0.44772 48 0 47.5523 0 47V17Z"
                fill="black"
                fillOpacity="0.04"
            />
            <path
                d="M0 65C0 64.4477 0.447715 64 1 64H149C149.552 64 150 64.4477 150 65V258C150 258.552 149.552 259 149 259H0.999999C0.447714 259 0 258.552 0 258V65Z"
                fill="black"
                fillOpacity="0.04"
            />
            <path
                d="M174 65C174 64.4477 174.448 64 175 64H845C845.552 64 846 64.4477 846 65V84C846 84.5523 845.552 85 845 85H175C174.448 85 174 84.5523 174 84V65Z"
                fill="black"
                fillOpacity="0.04"
            />
            <path
                d="M174 102C174 101.448 174.448 101 175 101H845C845.552 101 846 101.448 846 102V128C846 128.552 845.552 129 845 129H175C174.448 129 174 128.552 174 128V102Z"
                fill="black"
                fillOpacity="0.04"
            />
            <path
                d="M174 146C174 145.448 174.448 145 175 145H345C345.552 145 346 145.448 346 146V165C346 165.552 345.552 166 345 166H175C174.448 166 174 165.552 174 165V146Z"
                fill="black"
                fillOpacity="0.04"
            />
            <path
                d="M174 183C174 182.448 174.448 182 175 182H345C345.552 182 346 182.448 346 183V202C346 202.552 345.552 203 345 203H175C174.448 203 174 202.552 174 202V183Z"
                fill="black"
                fillOpacity="0.04"
            />
        </svg>
    );
}
